import { useQuery } from '@tanstack/react-query'
import { stockAnalysisService } from '@/services'
import { stockAnalysisQueryKeys } from './query-keys'

export const useGetStockAnalysisQuery = (ticker: string, enabled = true) => {
  return useQuery({
    queryKey: stockAnalysisQueryKeys.detail(ticker),
    queryFn: () => stockAnalysisService.getByTicker(ticker),
    enabled: !!ticker && enabled,
    staleTime: 1000 * 60 * 60, // 1h — dados mudam no máximo uma vez por dia
  })
}
